<div class="reservation-list-component">
  <div class="scrollbar-overflow">
    <mat-paginator hidden #paginatorTop [length]="dataSource.elementsSubject$ | async" (page)="handlePageTop($event)"
      showFirstLastButtons>
    </mat-paginator>
    <div class="table-container">
      <table mat-table matSort matTableFilter matSortActive="createdAt" matSortDirection="desc" [dataSource]="dataSource"
        matSortDisableClear class="scrollbar-table scrollable-table">
        <ng-container matColumnDef="id" class="mat-column-id">
          <th mat-header-cell mat-sort-header *matHeaderCellDef class="align-left">{{'Booking ID' | translate}}</th>
          <td mat-cell *matCellDef="let wineryScheduling" class="align-left">
            <span [wsAdminTooltip]="wineryScheduling.id">{{ wineryScheduling.id | wsAdminIdDisplay }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="experienceTitleIt" class="mat-column-experience-title">
          <th mat-header-cell mat-sort-header *matHeaderCellDef class="align-left">
            {{ "Experience" | translate }}
          </th>
          <td mat-cell *matCellDef="let wineryScheduling" class="align-left">
            {{ getExperienceName(wineryScheduling) }}
          </td>
        </ng-container>

        <ng-container class="mat-column-name" matColumnDef="masterContactName">
          <th mat-header-cell mat-sort-header *matHeaderCellDef class="align-left">
            {{ "Client contact" | translate }}
          </th>
          <td *matCellDef="let wineryScheduling" class="align-left" mat-cell>
            {{ getMasterContactName(wineryScheduling) }}
          </td>
        </ng-container>

        <ng-container class="mat-column-adults" matColumnDef="guestCountTotal">
          <th *matHeaderCellDef class="align-left" mat-header-cell mat-sort-header>
            {{ "Partecipants" | translate }}
          </th>
          <td *matCellDef="let wineryScheduling" mat-cell>
            <div class="infoIconParticipantsWrapper">
              {{ wineryScheduling.guestCountTotal }}
              <web-info-icon-hoverable class="infoIconParticipants" [tooltipClass]="'ws-multiline-tooltip'"
                [descriptionObservable]="generateInfoCall(wineryScheduling)">
              </web-info-icon-hoverable>
            </div>
          </td>
        </ng-container>

        <ng-container class="mat-column-created_at" matColumnDef="createdAt">
          <th mat-header-cell mat-sort-header *matHeaderCellDef class="align-left date-header-cell">
            {{ "Reservation date" | translate }}
          </th>
          <td *matCellDef="let wineryScheduling" mat-cell class="order-datetime-cell">
            <ng-container *ngIf="getReservationCreatedAtCell(wineryScheduling) as dt; else noCreatedAt">
              <div>{{ dt.date }}</div>
              <div *ngIf="dt.time" class="time-text">{{ dt.time }}</div>
            </ng-container>
            <ng-template #noCreatedAt>—</ng-template>
          </td>
        </ng-container>

        <ng-container class="mat-column-start_at" matColumnDef="date">
          <th mat-header-cell mat-sort-header *matHeaderCellDef class="align-left date-header-cell">
            {{ "Experience date" | translate }}
          </th>
          <td *matCellDef="let wineryScheduling" mat-cell class="order-datetime-cell">
            <ng-container *ngIf="getExperienceDateCell(wineryScheduling) as dt; else noExperienceDate">
              <div>{{ dt.date }}</div>
              <div *ngIf="dt.time" class="time-text">{{ dt.time }}</div>
            </ng-container>
            <ng-template #noExperienceDate>—</ng-template>
          </td>
        </ng-container>

        <ng-container matColumnDef="reservationOrigin" class="mat-column-origin">
          <th mat-header-cell mat-sort-header *matHeaderCellDef class="align-left">
            {{ "Origin" | translate }}
          </th>
          <td mat-cell *matCellDef="let wineryScheduling">
            {{
            wineryScheduling.isTourOperator
            ? "Tour Operator"
            : getOrigin(wineryScheduling)
            ? (getOrigin(wineryScheduling) | translate)
            : ("Not specified feminine" | translate)
            }}
          </td>
        </ng-container>

        <ng-container matColumnDef="origin" class="mat-column-origin">
          <th mat-header-cell mat-sort-header *matHeaderCellDef class="align-left">
            {{ "Typology" | translate }}
          </th>
          <td mat-cell *matCellDef="let wineryScheduling">
            {{
            wineryScheduling.isTourOperator
            ? "Tour Operator"
            : getTypology(wineryScheduling)
            ? getTypology(wineryScheduling)
            : ("Not specified feminine" | translate)
            }}
          </td>
        </ng-container>

        <ng-container class="mat-column-total" matColumnDef="netTotalCents">
          <th mat-header-cell mat-sort-header *matHeaderCellDef class="align-left">
            {{ "Total" | translate }}
          </th>
          <td *matCellDef="let wineryScheduling" mat-cell>
            {{
            wineryScheduling.type == "appointment"
            ? ""
            : (((wineryScheduling.netTotalCents || 0) +
            (wineryScheduling.giftAmountCents || 0)) /
            100
            | currency
            : wineryScheduling.paymentCurrency
            : "symbol"
            : "1.0-2")
            }}
          </td>
        </ng-container>

        <ng-container class="mat-column-paid" matColumnDef="paid">
          <th mat-header-cell mat-sort-header *matHeaderCellDef class="align-left">
            {{ "Paid Check" | translate }}
          </th>
          <td *matCellDef="let wineryScheduling" mat-cell>
            {{ (wineryScheduling.paid ? "Yes" : "No") | translate }}
          </td>
        </ng-container>

        <ng-container class="mat-column-due" matColumnDef="due">
          <th mat-header-cell *matHeaderCellDef class="align-left">
            {{ "Due" | translate }}
          </th>
          <td *matCellDef="let wineryScheduling" mat-cell>
            {{
            wineryScheduling.type == "appointment"
            ? ""
            : ((wineryScheduling.dueTotalCents || 0) / 100
            | currency
            : wineryScheduling.paymentCurrency
            : "symbol"
            : "1.0-2")
            }}
          </td>
        </ng-container>

        <ng-container class="mat-column-paymentDate" matColumnDef="paymentDate">
          <th mat-header-cell *matHeaderCellDef class="align-left date-header-cell">
            {{ "Payment date" | translate }}
          </th>
          <td *matCellDef="let wineryScheduling" mat-cell
            class="order-datetime-cell"
            [wsTooltip]="getPaymentDateTooltip(wineryScheduling)">
            <ng-container *ngIf="wineryScheduling.type !== 'appointment'">
              <ng-container *ngIf="getPaymentDateCell(wineryScheduling) as dt; else noPaymentDate">
                <div>{{ dt.date }}</div>
                <div *ngIf="dt.time" class="time-text">{{ dt.time }}</div>
              </ng-container>
              <ng-template #noPaymentDate>—</ng-template>
            </ng-container>
          </td>
        </ng-container>

        <ng-container class="mat-column-invoiceData" matColumnDef="invoiceData">
          <th mat-header-cell *matHeaderCellDef class="align-left">
            {{ "Invoice Request" | translate }}
          </th>
          <td *matCellDef="let wineryScheduling" mat-cell>
            {{
            wineryScheduling.type == "appointment"
            ? ""
            : ((wineryScheduling.otherData?.invoiceData && wineryScheduling.otherData?.invoiceData !== "{}" ? "Yes" :
            "No")
            | translate)
            }}
          </td>
        </ng-container>

        <ng-container class="mat-column-isSales" matColumnDef="isSales">
          <th mat-header-cell *matHeaderCellDef class="align-left">
            {{ "isSales" | translate }}
          </th>
          <td *matCellDef="let wineryScheduling" mat-cell>
            {{
            wineryScheduling.type == "appointment"
            ? ""
            : ((wineryScheduling.otherData?.isSales === "true" ||
            wineryScheduling.otherData?.isSales === true
            ? "Yes"
            : "No"
            ) | translate)
            }}
          </td>
        </ng-container>

        <ng-container class="mat-column-checkedIn" matColumnDef="checkedIn">
          <th mat-header-cell *matHeaderCellDef class="align-left">
            {{ "checkedIn" | translate }}
          </th>
          <td *matCellDef="let wineryScheduling" mat-cell>
            {{
            wineryScheduling.type == "appointment"
            ? ""
            : ((wineryScheduling.otherData?.checkedIn === "true" ||
            wineryScheduling.otherData?.checkedIn === true
            ? "Yes"
            : "No"
            ) | translate)
            }}
          </td>
        </ng-container>

        <ng-container matColumnDef="state" class="mat-column-state">
          <th mat-header-cell *matHeaderCellDef class="align-left status-cell">
            {{ "Status" | translate }}
          </th>
          <td mat-cell *matCellDef="let wineryScheduling" class="status-cell">
            <ws-chip
              [label]="statusFn(wineryScheduling) | firstupper | translate"
              [type]="statusBgColorFn(wineryScheduling)"
            ></ws-chip>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row class="reservation-row clickable" *matRowDef="let row; columns: displayedColumns"
        (click)="rowClicked(row)"></tr>
      </table>
    </div>
  </div>
  <mat-paginator #paginatorBottom [length]="dataSource.elementsSubject$ | async" [pageSizeOptions]="[10, 20, 50]"
    [pageSize]="pageSize" showFirstLastButtons="false" (page)="handlePageBottom($event)">
  </mat-paginator>
</div>